export default __webpack_public_path__ + "static/media/SensorPelvisLeft.37a61ab8.svg";